















































































































































































































































































































































































import { Vue, Component, Prop } from "vue-property-decorator";
import { StudentAssignmentInfo } from "../../_models/studentAssignment";

@Component
export default class DetailsInfoAlternanza extends Vue {
  @Prop() info!: StudentAssignmentInfo;

}
